import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './SubmissionSection.module.css'

interface SubmissionSectionProps {
  children?: ReactNode
  compact?: boolean
}

export function SubmissionSection({
  children,
  compact,
}: SubmissionSectionProps) {
  return (
    <div className={cx(styles.root, compact && styles.compact)}>{children}</div>
  )
}

interface SubmissionSectionHeaderProps {
  label: ReactNode
  children?: ReactNode
  compact?: boolean
}

export function SubmissionSectionHeader({
  label,
  children,
  compact,
}: SubmissionSectionHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={cx(styles.label, compact && styles.compact)}>{label}</div>
      <div>{children}</div>
    </div>
  )
}
